import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const meetupRoutes = [
  {
    key: "meetup-list",
    exact: true,
    path: `${APP_PREFIX_PATH}/meetup/meetup-list`,
    component: React.lazy(() => import("views/app-views/meetup/pages/MeetupList")),
  },
  {
    key: "create-meetup",
    exact: true,
    path: `${APP_PREFIX_PATH}/meetup/create-meetup`,
    component: React.lazy(() => import("views/app-views/meetup/pages/CreateMeetup")),
  },
  {
    key: "meetup-summary",
    exact: true,
    path: `${APP_PREFIX_PATH}/meetup/meetup-summary/:id`,
    component: React.lazy(() => import("views/app-views/meetup/pages/MeetupSummary")),
  },
];
